import { useCallback, useEffect, useState } from "react";
import ContentsTopHeader from "../../../components/common/contents.top.header";
import { UserListContainer } from "../../../style/contents/backup/backup";
import { fetchBackupUserListLoad } from "../../../api/admin";
import UserTableList from "../../../components/user/user.table.list";

export interface UserProfile {
  userId: number;
  userAccount: string;
  userName: string;
  userEmail?: string; // 선택적: ""
  password: string;
  isAdmin: boolean;
  companyId: number;
  macAddress: string[]; // 배열
  phoneNumber?: string; // 선택적: ""
  department?: string; // 선택적: ""
  jobPosition?: string; // 선택적: "과장" 포함 가능
  createdDate?: string; // 선택적: "2025-07-16 12:49:46.795483"
}

type UserListType = UserProfile[];

const UserList = () => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [pageSize, setPageSize] = useState("10");
  const [data, setData] = useState<UserListType>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = (keyword: string) => {
    setSearchKeyword(keyword);
    // TODO: fetchData(keyword, pageSize);
  };

  const handlePageSizeChange = (size: string) => {
    setPageSize(size);
    // TODO: fetchData(searchKeyword, size);
  };

  const loadUserList = useCallback(async () => {
    setIsLoading(true); // ✅ 로딩 시작
    try {
      const userId = localStorage.getItem("userId");
      const companyCode = localStorage.getItem("companyCode");

      const response = await fetchBackupUserListLoad(
        Number(userId),
        companyCode || ""
      );
      setData(response.userList);
    } catch (err) {
      console.error("🚨 사용자 목록 불러오기 실패:", err);
    } finally {
      setIsLoading(false); // ✅ 로딩 종료
    }
  }, []);

  useEffect(() => {
    loadUserList();
  }, [loadUserList]);

  const normalizedKeyword = searchKeyword.trim().toLowerCase();
  const filteredData = data.filter((user) => {
    const keyword = normalizedKeyword;

    const isAdminText = user.isAdmin ? "관리자" : "사용자";

    return (
      user.userAccount.toLowerCase().includes(keyword) ||
      user.userName.toLowerCase().includes(keyword) ||
      user.department?.toLowerCase().includes(keyword) ||
      user.jobPosition?.toLowerCase().includes(keyword) ||
      user.userEmail?.toLowerCase().includes(keyword) ||
      isAdminText.includes(keyword) // ✅ 권한 정보 포함
    );
  });

  return (
    <UserListContainer>
      {" "}
      <ContentsTopHeader
        title="구성원 목록"
        onSearch={handleSearch}
        onPageSizeChange={handlePageSizeChange}
        className="user-list-top-header"
      />
      <div className="contents-body">
        <UserTableList
          data={filteredData}
          pageSize={parseInt(pageSize)}
          onUpdateSuccess={loadUserList} // ✅ 수정 성공 후 갱신용
          isLoading={isLoading}
        />
      </div>
    </UserListContainer>
  );
};

export default UserList;
